import { z } from 'zod'
export const eduInternDetailsSearchSchema = z.object({
  tab: z.enum(['diary', 'info', 'agreement', 'plan', 'absence', 'log']).catch('diary'),
  page: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(25),
  sortBy: z.enum(['date', 'programitem', 'org', 'time', 'academichours', 'grade']).catch('date'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
})
export type EduInternDetailsSearch = z.infer<typeof eduInternDetailsSearchSchema>
export const defaultEduInternDetailsSearch = eduInternDetailsSearchSchema.parse({})
